<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { RequestItemEntity } from "@shared/services/event_tracking/entities";

  const { trackMrcEvents } = EventTracking;

  export let tooltipPosition: string = "fizz-tooltip-left";
  export let distributor: any;
  export let product: any;

  let tooltipHovered: boolean = false;

  const trackingParams = [
    new RequestItemEntity({ distributor_id: distributor.id, product_id: product.id }),
  ];
</script>

<style>
  .tooltip-text {
    border-bottom: 1px dashed #595959;
    font-weight: 400;
  }
</style>

<div
  class="fizz-tooltip-container fizz-stack-12 flex items-center gap-4"
  data-testid="learn-more-allocated-tooltip"
>
  <Icon
    type="InfoYellow"
    extraClassNames="fizz-text-warning cursor-pointer"
    height="16"
    width="16"
  />
  <p class="fizz-text-subdued">Allocated</p>
  <p
    class="tooltip-text fizz-tooltip-trigger fizz-text-subdued"
    aria-describedby="learn-more-tooltip"
    on:mouseenter={() => (tooltipHovered = true)}
    on:mouseleave={() => (tooltipHovered = false)}
  >
    Learn more
  </p>
  {#if tooltipHovered}
    <p
      class={`fizz-tooltip fizz-tooltip-top ${tooltipPosition}`}
      role="tooltip"
      id="learn-more-tooltip"
      style="--min-width: 100px; --max-width: 250px;"
      use:trackMrcEvents={trackingParams}
    >
      Fulfillment of this item is determined at the discretion of the distributor.
    </p>
  {/if}
</div>
